import { HorizontalRule } from "@mui/icons-material";

export const StepItemConfig = {
    type: 18,
    label: 'Step',
    icon: HorizontalRule,
    allowedBy: [17],
    autoConfig: false,
}